import useTableData from "../../../../state/table/UseTableData";

const useTableBody = () => {
  const { tableState } = useTableData();

  return {
    sortedData: tableState.sortedData,
  };
};

export default useTableBody;